<template>
  <div :class="layout + ' ' + classes" class="child">
    <div class="img-txt-inner">
      <img :src="getSrc(img)" :style="{'max-width': imgWidth + 'px'}" alt="">
      <div class="txt" :style="{'max-width': (parseInt(imgWidth) * 2.5) + 'px'}">
        <h6>{{title}}</h6>
        <p v-if="txt">{{txt}}</p>
        <p v-if="rawHtml" v-html="rawHtml"></p>
        <a v-if="ctaCopy" :href="ctaLink">{{ctaCopy}}</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'img-text',
  props: ['img', 'txt', 'rawHtml', 'title', 'imgWidth', 'layout', 'ctaCopy', 'ctaLink', 'classes'],
  methods: {
    getSrc: function (value) {
      var src = require('./images/' + value)
      return src
    }
  }
}
</script>

<style scoped lang="stylus" src="./img-text.styl" >



// WEBPACK FOOTER //
// src/components/img-text/img-text.vue